/**
 * The broker's session token, kept apart from the buyer login ("ogm_token"). Listeners hear about logout/expiry so the
 * broker top bar and dashboard can react.
 */
const BROKER_TOKEN_KEY = "brokerToken";
export const BROKER_SESSION_EVENT = "ogm:broker-session";

const safe = (fn, fallback = null) => {
    try { return fn(); } catch { return fallback; }
};

const notify = () => window.dispatchEvent(new Event(BROKER_SESSION_EVENT));

export const brokerSession = {
    get: () => safe(() => localStorage.getItem(BROKER_TOKEN_KEY)),
    set: (token) => { safe(() => localStorage.setItem(BROKER_TOKEN_KEY, token)); notify(); },
    remove: () => { safe(() => localStorage.removeItem(BROKER_TOKEN_KEY)); notify(); },
    expire: () => {
        if (!brokerSession.get()) return;
        brokerSession.remove();
    },
};
